import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVehicle } from "../vehicleModel";

export const getAllVehicle = createAsyncThunk(
  "Vehicles/FindAllVehicles",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Vehicles/FindAllVehicles`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVehicle = createAsyncThunk(
  "Vehicles/InsertVehicles",
  async (VehicleData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Vehicles/InsertVehicles`,
        VehicleData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVehicle = createAsyncThunk(
  "Vehicles/UpdateVehicles",
  async (VehicleData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Vehicles/UpdateVehicles`,
        VehicleData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVehicle = createAsyncThunk(
  "Vehicles/DeleteVehicles",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Vehicles/DeleteVehicles`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVehicleByID = createAsyncThunk(
  "Vehicles/FindByIDVehicles",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Vehicles/FindByIDVehicles`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        CityID: result.CityID,
        VehicleTypeID: result.VehicleTypeID,
        NoOfSeats: result.NoOfSeats,
        KmPerDay: result.KmPerDay,
        RatePerKm: result.RatePerKm,
        DriverAllowancePerDay: result.DriverAllowancePerDay,
        PickUpWithinCity: result.PickUpWithinCity,
        DropWithinCity: result.DropWithinCity,
        EightHrEightyKmWithinCity: result.EightHrEightyKmWithinCity,
        IsActive: result.IsActive === true ? 1 : 2,
      } as IVehicle;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveVehicle = createAsyncThunk(
  "Vehicles/FindAllActiveVehicles",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Vehicles/FindAllActiveVehicles`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveVehicle = createAsyncThunk(
  "Vehicles/ActiveInActiveVehicles",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Vehicles/ActiveInActiveVehicles`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Vehicle:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
